import { dispatch } from '@rematch/core';
import {
    notificationsService,
    accountNotificationsCountService,
    myNotificationsService,
    MarkReadNotificationsService,
    workspaceNotificationsCountService,
    allWorkspaceNotificationsService
} from '../../services/feathers.service';


const initialState = {
    allNotification: [],
    eventStreamArray: [],
    notificationsCount: {},
    filterQuery: {},
    eventStreamCount: {},
    eventStreamArrayForCommunity: [],
    recentUpdates: [],
    recentUpdatesForTeam: [],
    eventStreamArrayForTeam: [],
    eventStreamArrayForUserIdAndTeamId: [],
    recentUpdatesForTeamIdAndUserId: []
};


export default {
    state: initialState,
    reducers: {
        setAllNotification(state, payload) {
            return {
                ...state,
                allNotification: payload
            }
        },
        setEventStream(state, payload) {
            return {
                ...state,
                eventStreamArray: payload
            }
        },
        setNotificationsCount(state, payload) {
            return {
                ...state,
                notificationsCount: payload
            }
        },
        setEventStreamForCommunity(state, payload) {
            return {
                ...state,
                eventStreamArrayForCommunity: payload
            }
        },
        filterQueryData(state, payload) {
            return {
                ...state,
                filterQuery: payload
            }
        },
        setEventStreamCount(state, payload) {
            return {
                ...state,
                eventStreamCount: payload
            }
        },
        setRecentUpdates(state, payload) {
            return {
                ...state,
                recentUpdates: payload
            }
        },
        setEventStreamForTeamId(state, payload) {
            return {
                ...state,
                eventStreamArrayForTeam: payload
            }
        },
        setRecentUpdatesForTeamId(state, payload) {
            return {
                ...state,
                recentUpdatesForTeam: payload
            }
        },
        setEventStreamForUserIdAndTeamId(state, payload) {
            return {
                ...state,
                eventStreamArrayForUserIdAndTeamId: payload
            }
        },
        setRecentUpdatesForTeamIdAndUserId(state, payload) {
            return {
                ...state,
                recentUpdatesForTeamIdAndUserId: payload
            }
        },
        incrementNotificationCount(state, payload) {
            return {
                ...state,
                notificationsCount: {
                    total: state.notificationsCount.total + 1,
                    readCount: state.notificationsCount.readCount + 1
                }
            }
        },
        clear() {
            return initialState
        }
    },
    effects: {
        async getNotifications(payload, state) {
            try {

                let serviceNameArr = ['practices', 'initiatives', 'contents', 'suborganizations', 'accounts', 'organizations', 'initiativeActivities']
                let query = {
                    $limit: 25,
                    $sort: { createdAt: 1 },
                    sortingType: state.notifications.filterQuery.sortingType,
                }

                //  filter by name
                if (state.notifications.filterQuery.name) {
                    query.name = state.notifications.filterQuery.name;
                }

                //  Services 
                if (state.notifications.filterQuery.serviceName && state.notifications.filterQuery.serviceName.length > 0) {
                    query.serviceName = state.notifications.filterQuery.serviceName
                } else {
                    query.serviceName = serviceNameArr
                }

                // set Limit
                if (state.notifications.filterQuery.limit) {
                    query.$limit = state.notifications.filterQuery.limit
                }
                query.$sort.createdAt = state.notifications.filterQuery.sortingType ? state.notifications.filterQuery.sortingType : -1
                let myNotifications = await myNotificationsService.find({
                    query: query
                });

                // Set notification By limit notification
                await dispatch.notifications.getAllNotification(myNotifications);
            } catch (err) {
                throw err;
            }
        },
        async markAllAsRead(payload, state) {
            try {
                MarkReadNotificationsService.patch(null, {})
            } catch (err) {
                throw err;
            }
        },
        getAllNotification(payload) {
            dispatch.notifications.setAllNotification(payload);
        },
        async getEventStreamByOrganization(payload, state) {

            try {
                let serviceNameArr = ['practices', 'initiatives', 'contents', 'suborganizations', 'organizations', 'initiativeActivities']

                let query = {
                    serviceName: { $in: payload.serviceName },
                    $populate: [
                        { path: 'from', populate: 'from', select: '_id firstName lastName profilePic ' },
                    ],
                    $sort: { createdAt: -1 },
                    $limit: 10
                }

                // filter by name
                if (state.notifications.filterQuery.name) {
                    payload.name = state.notifications.filterQuery.name.replace(".", "\\.");
                    query["entityData.name"] = { $regex: state.notifications.filterQuery.name, $options: 'i' };
                }

                // filter to all and my data
                if (state.notifications.filterQuery.type === "my") {
                    query.$and = [];
                    query.$and.push({ to: state.app.user._id }, { from: state.app.user._id })
                } else {
                        query.to = state.app.user._id;                    
                }


                // sort data by old to new and viceversa

                query.$sort.createdAt = state.notifications.filterQuery.sortingType ? state.notifications.filterQuery.sortingType : -1


                // set Limit
                if (state.notifications.filterQuery.limit) {
                    query.$limit = state.notifications.filterQuery.limit
                }

                // Services 
                if (state.notifications.filterQuery.serviceName && state.notifications.filterQuery.serviceName.length > 0) {
                    query.serviceName = { $in: state.notifications.filterQuery.serviceName }
                } else {
                    query.serviceName = { $in: serviceNameArr }
                }
                let result = await notificationsService.find({ query: query });
                dispatch.notifications.setEventStreamData(result)

            } catch (err) {
                throw err;
            }
        },
        setEventStreamData(payload) {
            dispatch.notifications.setEventStream(payload);
        },

        async accountNotificationsCount(payload) {
            try {
                let result = await accountNotificationsCountService.find({ query: payload });
                dispatch.notifications.setNotificationsCount(result)

            } catch (err) {
                throw err;
            }
        },

        fetchNotificationIfNeeded(payload, state) {

            if (payload.recipentsArray.includes(state.app.user._id)) {
                dispatch.notifications.incrementNotificationCount();
                // dispatch.notifications.accountNotificationsCount({ accountId: payload.accountId, organizationId: payload.organizationId })
                if (state.app.currentContext === 'home') {
                    dispatch.notifications.getEventStreamByOrganization({ accountId: payload.accountId, organizationId: payload.organizationId })
                }

                // dispatch.notifications.getNotifications();
            }
        },
        setFilterQueryData(payload) {
            dispatch.notifications.filterQueryData(payload);
        },

        async getEventStreamForCommunity(payload, state) {
            try {
                let serviceNameArr
                if (payload.type === 'all') {
                    serviceNameArr = ['practices', 'initiatives', 'contents']
                }
                else {
                    serviceNameArr = [payload.type]
                }
                let query = {
                    serviceName: serviceNameArr,
                    limit: payload.limit,
                    role: payload.role
                }
                let result = await allWorkspaceNotificationsService.find({ query: query });
                dispatch.notifications.setEventStreamDataForCommunity(result)

            } catch (err) {
                throw err;
            }
        },
        setEventStreamDataForCommunity(payload) {
            dispatch.notifications.setEventStreamForCommunity(payload);
        },
        async getEventStreamCount(payload) {
            try {
                let result = await workspaceNotificationsCountService.find({ query: payload });
                dispatch.notifications.setEventStreamCountData(result)
            } catch (err) {
                throw err;
            }
        },
        setEventStreamCountData(payload) {
            dispatch.notifications.setEventStreamCount(payload);
        },

        async getRecentUpdates(payload, state) {
            try {
                let serviceNameArr = ['organizations', 'suborganizations', 'invites']
                let query = {
                    serviceName: serviceNameArr,
                    limit: payload.limit,
                    role: payload.role
                }
                let result = await allWorkspaceNotificationsService.find({ query: query });
                dispatch.notifications.setRecentUpdatesData(result)

            } catch (err) {
                throw err;
            }
        },

        setRecentUpdatesData(payload) {
            dispatch.notifications.setRecentUpdates(payload);
        },

        async getEventStreamForTeamId(payload, state) {
            try {
                let query = {
                    serviceName: { $in: payload.type },
                    $populate: [
                        { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                    ],
                    to: '999999999999999999999999',
                    teamId: payload.teamId,
                    $sort: { createdAt: -1 },
                    $limit: payload.limit
                }

                let result = await notificationsService.find({ query: query });
                dispatch.notifications.setEventStreamDataForTeamId(result)

            } catch (err) {
                throw err;
            }
        },
        setEventStreamDataForTeamId(payload) {
            dispatch.notifications.setEventStreamForTeamId(payload);
        },
        async getRecentUpdatesForTeamId(payload, state) {
            try {
                let serviceNameArr = ['suborganizations']
                let query = {
                    serviceName: { $in: serviceNameArr },
                    $populate: [
                        { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                    ],
                    to: '999999999999999999999999',
                    teamId: payload.teamId,
                    $sort: { createdAt: -1 },
                    $limit: payload.limit
                }

                let result = await notificationsService.find({ query: query });
                dispatch.notifications.setRecentUpdatesDataForTeamId(result)

            } catch (err) {
                throw err;
            }
        },
        setRecentUpdatesDataForTeamId(payload) {
            dispatch.notifications.setRecentUpdatesForTeamId(payload);
        },

        async getEventStreamForUserIdAndTeamId(payload, state) {
            try {
                let query
                if (payload.organizationId === payload.teamId) {
                    query = {
                        serviceName: { $in: payload.type },
                        $populate: [
                            { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                        ],
                        from: payload.userId,
                        to: '999999999999999999999999',
                        organizationId: payload.organizationId,
                        $sort: { createdAt: -1 },
                        $limit: payload.limit
                    }
                }
                else {
                    query = {
                        serviceName: { $in: payload.type },
                        $populate: [
                            { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                        ],
                        from: payload.userId,
                        to: '999999999999999999999999',
                        teamId: payload.teamId,
                        $sort: { createdAt: -1 },
                        $limit: payload.limit
                    }
                }

                let result = await notificationsService.find({ query: query });
                dispatch.notifications.setEventStreamDataForUserIdAndTeamId(result)

            } catch (err) {
                throw err;
            }
        },
        setEventStreamDataForUserIdAndTeamId(payload) {
            dispatch.notifications.setEventStreamForUserIdAndTeamId(payload);
        },
        async getRecentUpdatesForTeamIdAndUserId(payload, state) {
            try {
                let query
                let serviceNameArr = ['organizations', 'suborganizations']
                if (payload.organizationId === payload.teamId) {
                    query = {
                        serviceName: { $in: serviceNameArr },
                        $populate: [
                            { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                        ],
                        from: payload.userId,
                        to: '999999999999999999999999',
                        organizationId: payload.organizationId,
                        $sort: { createdAt: -1 },
                        $limit: payload.limit
                    }
                }
                else {
                    query = {
                        serviceName: { $in: serviceNameArr },
                        $populate: [
                            { path: 'from', populate: 'from', select: '_id firstName lastName profilePic' },
                        ],
                        from: payload.userId,
                        to: '999999999999999999999999',
                        teamId: payload.teamId,
                        $sort: { createdAt: -1 },
                        $limit: payload.limit
                    }
                }
                let result = await notificationsService.find({ query: query });
                dispatch.notifications.setRecentUpdatesDataForTeamIdAndUserId(result)

            } catch (err) {
                throw err;
            }
        },
        setRecentUpdatesDataForTeamIdAndUserId(payload) {
            dispatch.notifications.setRecentUpdatesForTeamIdAndUserId(payload);
        },

        clearAsync() {
            dispatch.notifications.clear();
        },

    },

}